/*
    Cleaned base.js for InsuJet
*/

// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => new bootstrap.Tooltip(el));

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => new bootstrap.Popover(el));

// Shopify challenge page - add Bootstrap classes
document.querySelector('.btn.shopify-challenge__button')?.classList.add('btn-primary');

// Shopify error messages - add Bootstrap classes
const errors = document.querySelector('.errors');
if (errors) {
    errors.classList.add('alert', 'alert-danger');
}

// Shopify money format helper
Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || this.money_format;

    function defaultOption(opt, def) {
        return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsPart = parts[1] ? decimal + parts[1] : '';
        return dollars + centsPart;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

// Resize Shopify images helper
Shopify.resizeImage = (src, size, crop = '') =>
    src
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
            if (crop.length) crop = `_crop_${crop}`;
            return `_${size}${crop}${match}`;
        });

// Debounce helper
window.debounce = (callback, wait = 200) => {
    let timeout;
    return (...args) => {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => callback.apply(context, args), wait);
    };
};

// Throttle helper
window.throttle = (callback, timeFrame = 200) => {
    let lastTime = 0;
    return function () {
        const now = Date.now();
        if (now - lastTime >= timeFrame) {
            callback();
            lastTime = now;
        }
    };
};

// Create cookie helper
window.createCookie = (name, value, days) => {
    let date, expires;
    if (days) {
        date = new Date();
        date.setDate(date.getDate() + days);
        expires = '; expires=' + date.toUTCString();
    } else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};

// Detect elements entering view
const initEnterView = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('entered');
                entry.target.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
                    el.classList.remove('opacity-0');
                    el.classList.add(el.dataset.animateClass);
                });
            }
        });
    }, { threshold: 0, rootMargin: '0px 0px -200px 0px' });

    document.querySelectorAll('.enter-view').forEach((el) => observer.observe(el));
};
initEnterView();

// Lazy load HTML5 videos
const initVideoLazyLoad = () => {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy-video'));
    if ('IntersectionObserver' in window) {
        const lazyVideoObserver = new IntersectionObserver((entries) => {
            entries.forEach((video) => {
                if (video.isIntersecting) {
                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }
                    video.target.load();
                    if (video.target.hasAttribute('data-poster')) {
                        video.target.poster = video.target.dataset.poster;
                    }
                    video.target.classList.remove('lazy-video');
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        }, { threshold: 0, rootMargin: '0px 0px 200px 0px' });

        lazyVideos.forEach((lazyVideo) => lazyVideoObserver.observe(lazyVideo));
    }
};
initVideoLazyLoad();

document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.enter-view').forEach((elem) => {
        elem.classList.add('entered');
        document.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
            el.classList.remove('opacity-0');
        });
    });
});

// ✅ Variant selector dynamic text handling
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-option').forEach(option => {
        option.addEventListener('change', () => {

            // SIZE HANDLING
            if (option.value === '3ml') {
                document.querySelector('[data-size-option="3ml"]')?.removeAttribute('hidden');
                document.querySelector('[data-size-option="10ml"]')?.setAttribute('hidden', 'hidden');
            } else if (option.value === '10ml') {
                document.querySelector('[data-size-option="3ml"]')?.setAttribute('hidden', 'hidden');
                document.querySelector('[data-size-option="10ml"]')?.removeAttribute('hidden');
            }

            // INJECTOR MODEL HANDLING
            if (option.value === 'Model M') {
                document.querySelector('[data-model-option="Model M"]')?.removeAttribute('hidden');
                document.querySelector('[data-model-option="Model S"]')?.setAttribute('hidden', 'hidden');
            } else if (option.value === 'Model S') {
                document.querySelector('[data-model-option="Model M"]')?.setAttribute('hidden', 'hidden');
                document.querySelector('[data-model-option="Model S"]')?.removeAttribute('hidden');
            }
        });
    });
});
